export enum TipoMatchConciliacaoEnum {
    Movimentacao = 1,
    ContaPagar   = 2,
    ContaReceber = 3
}
